export default "__VITE_ASSET__sMMeMs$1__"